export default __webpack_public_path__ + "static/media/faq-image.2f3c74b4.svg";